import globalStyles from '../../styles/ButtonGradient.module.css';
import { HiUsers } from 'react-icons/hi';

const MyAthletesPanelToggleButton = ({ onClick }) => {
  return (
    <button
      className={globalStyles.button}
      onClick={onClick || (() => console.log('My Athletes clicked'))}
    >
      <HiUsers className={globalStyles.icon} />
      My Athletes
    </button>
  );
};

export default MyAthletesPanelToggleButton;